import styled from 'styled-components';

export default styled.div`
  
    display: flex;

    left: 50%;
    color: #058fe6;
    justify-content: center;
    align-items: center;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    border: 1px solid #058fe6;
    padding: 1.2rem;
    font-size: 1.4rem;
    cursor: help;
    z-index: 2;
`;
